"use client"

import React, { useState, useEffect } from 'react'
import { motion } from 'framer-motion'
import { Button } from "@/components/ui/button"
import Link from 'next/link'
import { useTranslations } from 'next-intl'

const GlitchText = ({ children }: { children: React.ReactNode }) => (
  <div className="glitch" data-text={children}>
    {children}
  </div>
)

export default function PageError({ errors }: any) {
  const t = useTranslations("errors");
  const [score, setScore] = useState(0)
  const [gameOver, setGameOver] = useState(false)
  const [position, setPosition] = useState({ x: 0, y: 0 })

  useEffect(() => {
    const interval = setInterval(() => {
      setPosition({
        x: Math.random() * (window.innerWidth - 50),
        y: Math.random() * (window.innerHeight - 50),
      })
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  const handleClick = () => {
    if (!gameOver) {
      setScore(score + 1)
      if (score + 1 >= 10) {
        setGameOver(true)
      }
    }
  }

  const BackgroundLines = () => {
    const [lines, setLines] = useState<React.ReactNode[]>([])
    useEffect(() => {
      const newLines = [...Array(50)].map((_, i) => (
        <motion.div
          key={i}
          className="absolute bg-blue-500"
          style={{
            width: Math.random() * 2 + 1,
            height: Math.random() * 10 + 5,
            top: `${Math.random() * 100}%`,
            left: `${Math.random() * 100}%`,
          }}
          animate={{
            opacity: [0, 1, 0],
            height: ["5px", "20px", "5px"],
          }}
          transition={{
            duration: Math.random() * 2 + 1,
            repeat: Infinity,
            repeatType: "reverse",
          }}
        />
      ))
      setLines(newLines)
    }, [])
    return <>{lines}</>
  }


  return (
    <div className="h-screen bg-black flex flex-col items-center justify-center overflow-hidden relative">
      <motion.div
        className="text-center z-10"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <GlitchText>
          <h1 className="text-9xl font-bold text-white mb-4">{errors.code}</h1>
        </GlitchText>
        <p className="text-2xl text-red-500 mb-8">{errors.title}</p>
        <p className="text-white mb-4">{errors.message}</p>
        <Button asChild className="bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-4 rounded-full transition-all duration-200 transform hover:scale-105 mr-1">
          <Link href="/">
            {t("return_to_home")}
          </Link>
        </Button>
        <Button asChild className="bg-green-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded-full transition-all duration-200 transform hover:scale-105 ml-1">
          <Link href="/">
            {t("report_error")}
          </Link>
        </Button>
      </motion.div>

      {!gameOver && (
        <motion.div
          className="absolute w-5 h-5 bg-red-500 rounded-full cursor-pointer"
          style={{ left: position.x, top: position.y }}
          animate={{ scale: [1, 1.2, 1] }}
          transition={{ repeat: Infinity, duration: 0.5 }}
          onClick={handleClick}
        />
      )}

      <BackgroundLines />
    </div>
  )
}

